import { DateTime } from 'luxon';
import { ValidateJSModel } from 'forms/shared/types';
import { getSafeDateTime } from 'helpers/date';
import { DateModelValidatorModel } from './types';

const dateModelValidator: ValidateJSModel<DateModelValidatorModel> = {
  estimated: {},
  day: (value, attributes, attributeName, options) => {
    // We intentionally use Day 1, versus the actual date, in order to get the
    // daysInMonth.
    const date = DateTime.fromFormat(`${attributes.month}/01/${attributes.year}`, 'MM/dd/yyyy');

    if (options.requireDay === false) { return {}; }

    return {
      presence: true,
      numericality: {
        onlyInteger: false,
        greaterThan: 0,
        lessThanOrEqualTo: date.daysInMonth ?? 31,
        notLessThanOrEqualTo: 'error.date.day.max',
        notGreaterThan: 'error.date.day.min',
      },
    };
  },
  month: (value, attributes, attributeName, options) => {
    if (options.requireMonth === false) { return {}; }

    return {
      presence: true,
      numericality: {
        onlyInteger: false,
        greaterThan: 0,
        lessThan: 13,
        notLessThan: 'error.date.month.notfound',
        notGreaterThan: 'error.date.month.notfound',
      },
    };
  },
  year: (value, attributes, attributeName, options) => {
    const earliest = getSafeDateTime(options.earliest);
    const latest = getSafeDateTime(options.latest);

    if (options.requireYear === false) { return {}; }

    return {
      presence: true,
      numericality: {
        onlyInteger: false,
        greaterThanOrEqualTo: earliest.valid === true ? earliest.datetime.get?.('year') : undefined,
        lessThanOrEqualTo: latest.valid === true ? latest.datetime.get?.('year') : undefined,
        notLessThanOrEqualTo: options.notLessThan || 'error.date.year.max',
        notGreaterThanOrEqualTo: options.notGreaterThan || 'error.date.year.min',
      },
    };
  },
  date: {
    required: (value, attributes, attributeName, options) => {
      const fields = [];

      if (options.requireDay) { fields.push('day'); }
      if (options.requireMonth) { fields.push('month'); }
      if (options.requireYear) { fields.push('year'); }

      return { fields };
    },
    datetime: (value, attributes, attributeName, options) => {
      if (options.earliest || options.latest) {
        return {
          earliest: options.earliest,
          latest: options.latest,
          tooLate: options.tooLate,
          tooEarly: options.tooEarly,
          notValid: options.notValid,
        };
      }

      return true;
    },
  },
};

export default dateModelValidator;
